import React from "react";

const Externallink = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M12 12L23 1M15 1h8v8M9 5H1v18h18v-8" />
    </g>
  </svg>
);

export default Externallink;



// WEBPACK FOOTER //
// ./src/theme/icons/Externallink.js